import { useState } from 'react';
import { getClientId } from '~/src/helpers/clientInfo';
import {
    sendRequestByConnection,
    parseRequestByConnection,
    dataLayerForCBPhonePushWrapper,
} from '~/src/api/service-request/request-by-connection';
import cookie from 'react-cookies';
import { ACTIONS } from '~/src/constants/analytics';
import { dataLayerForCBPhonePush } from '~/src/helpers/eventsForDataLayer';

export default (cityDomain, isPopup = false) => {

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState(null);

    const doSubmit = ({ name, phone, label }) => {

        setIsLoading(true);

        const clientId = cookie.load('_ga_cid');

        const dataParams = {
            petition: 'create_request',
            fio: name,
            phone: phone,
            domain: cityDomain,
            product_id: 5,
            tv_equipment_id: 80491,
            ga_cid: clientId ? clientId : getClientId(),
        };

        sendRequestByConnection(cityDomain, dataParams)
            .then(res => {
                const { message, status } = parseRequestByConnection(res);
                dataLayerForCBPhonePushWrapper({
                    billing_code: res.billing_code,
                    request_id: res.request_id,
                    isPopup,
                    option: label ?? '',
                });
                setStatus(status);
                setMessage(message);
                setIsLoading(false);
            })
            .catch(() => {

                setStatus('error');
                setMessage('Не удалось отправить заявку. Пожалуйста, попробуйте еще раз.');
                setIsLoading(false);

                dataLayerForCBPhonePush({
                    requestId: null,
                    action: ACTIONS.error,
                });
            });
    };

    return [{ status, isLoading, message }, doSubmit];
};
